export default class DataSetColStringEditor
{
	name;
    label;
    visible = true;
    helpText = null;
    displayLength = 20;
    alignment = "Center";
    stringSize = 20;
    type = "String";
}


// WEBPACK FOOTER //
// ./src/universalView/dataSet/DataSetColStringEditor.js